<template>
  <div>
    <main-layout>
      <MainMenu />
      <v-container>
        <v-layout wrap class="pt-4">
          <v-flex xs12>
            <h5>{{ $t('gpf_member') }}</h5>
          </v-flex>
          <v-flex xs12 class="text-sm-right text-xs-right">
            <v-btn dark outline color="primary" @click="handleSyncMember">
              <em class="fas fa-sync-alt" /><span class="pl-2">{{ $t('update') }}</span>
            </v-btn>
            <v-btn dark outline color="primary" @click="handleExportXlsx">
              <em class="fas fa-file-export" /><span class="pl-2">{{ $t('export') }}</span>
            </v-btn>
            <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em class="fas fa-angle-down" v-if="!showAdvancedSearch" />
              <em class="fas fa-angle-up" v-else />
            </v-btn>
          </v-flex>
          <v-flex class="pt-4">
            <div
              v-if="showAdvancedSearch"
              class="mb-4 py-2"
              style="border: 1px solid #eee; border-radius: 10px; position: relative"
            >
              <v-layout wrap class="form-control">
                <v-flex xs4 px-2>
                  <div class="caption">รหัสพนักงาน</div>
                  <input type="text" v-model="filter.gpf_user_id" placeholder="รหัสพนักงาน" />
                </v-flex>
                <v-flex xs4 px-2>
                  <div class="caption">ชื่อ</div>
                  <input type="text" v-model="filter.full_name" placeholder="ชื่อ" />
                </v-flex>
                <v-flex xs4 px-2>
                  <div class="caption">บริษัท</div>
                  <multiselect
                    v-model="filter.company_name"
                    :options="companyOptions"
                    :allow-empty="true"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                  ></multiselect>
                </v-flex>
                <v-flex xs4 px-2>
                  <div class="caption">ฝ่าย</div>
                  <multiselect
                    v-model="filter.group_name"
                    :options="groupOptions"
                    :allow-empty="true"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                  ></multiselect>
                </v-flex>
                <v-flex xs4 px-2>
                  <div class="caption">แผนก</div>
                  <multiselect
                    v-model="filter.department_name"
                    :options="departmentOptions"
                    :allow-empty="true"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                  ></multiselect>
                </v-flex>
                <v-flex xs4 px-2>
                  <div class="caption">ตำแหน่ง</div>
                  <multiselect
                    v-model="filter.position_name"
                    :options="positionOptions"
                    :allow-empty="true"
                    :searchable="true"
                    :openDirection="'bottom'"
                    selectLabel
                    selectedLabel
                    deselect-label
                  ></multiselect>
                </v-flex>

                <v-flex xs12 class="text-xs-right pt-2">
                  <v-btn outline color="grey" @click="handleClearSearch">{{
                    $t('Clear Search')
                  }}</v-btn>
                  <v-btn depressed @click="handleSearch" color="primary">
                    <em class="fas fa-search mr-1" />
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="memberListData"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template v-slot:items="props">
            <tr>
              <td class="py-1">
                <v-avatar size="48">
                  <v-img
                    :lazy-src="props.item.line_profile_pic"
                    :src="
                      props.item.line_profile_pic
                        ? props.item.line_profile_pic
                        : '/static/img/assets/livechat/profile.png'
                    "
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </v-avatar>
              </td>
              <td>{{ props.item.line_name }}</td>
              <td>{{ props.item.gpf_user_id }}</td>
              <td>{{ props.item.full_name || '-' }}</td>
              <td>{{ props.item.company_name || '-' }}</td>
              <td>{{ props.item.group_name || '-' }}</td>
              <td>{{ props.item.department_name || '-' }}</td>
              <td>{{ props.item.position_name || '-' }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="changePage"
            :length="pagelength"
          ></v-pagination>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import gpfBuddyApi from '@/api/gpf-buddy'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import Multiselect from 'vue-multiselect'
import MainMenu from './MainMenu.vue'

export default {
  components: {
    MainMenu,
    HeaderTableWithSort,
    Multiselect
  },
  data() {
    return {
      limit: 20,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      memberListData: [],
      headers: [
        { text: 'รูปโปรไฟล์ไลน์', value: 'line_profile_pic', sortable: false },
        { text: 'ชื่อไลน์', value: 'line_name', sortable: false },
        { text: 'รหัสพนักงาน', value: 'gpf_user_id', sortable: false },
        { text: 'ชื่อ', value: 'full_name', sortable: false },
        { text: 'บริษัท', value: 'company_name', sortable: false },
        { text: 'ฝ่าย', value: 'group_name', sortable: false },
        { text: 'แผนก', value: 'department_name', sortable: false },
        { text: 'ตำแหน่ง', value: 'position_name', sortable: false }
      ],
      showAdvancedSearch: false,
      filter: {
        gpf_user_id: '',
        full_name: '',
        company_name: '',
        group_name: '',
        department_name: '',
        position_name: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    gpfBuddyMasterData() {
      return this.$store.state.gpfBuddyMasterData || []
    },
    companyOptions() {
      const options = this.gpfBuddyMasterData.companies.map((el) => {
        return el.company_name
      })
      return options || []
    },
    groupOptions() {
      const tempOptions = this.gpfBuddyMasterData.groups.map((el) => {
        return el.group_name
      })

      let options = []
      tempOptions.forEach((opt) => {
        if (![...options].includes(opt)) {
          options.push(opt)
        }
      })

      return options
    },
    departmentOptions() {
      const tempOptions = this.gpfBuddyMasterData.departments.map((el) => {
        return el.department_name
      })

      let options = []
      tempOptions.forEach((opt) => {
        if (![...options].includes(opt)) {
          options.push(opt)
        }
      })

      return options
    },
    positionOptions() {
      const tempOptions = this.gpfBuddyMasterData.positions.map((el) => {
        return el.position_name
      })

      let options = []
      tempOptions.forEach((opt) => {
        if (![...options].includes(opt)) {
          options.push(opt)
        }
      })

      return options
    }
  },
  mounted() {
    this.handleGetMember()
    this.getGpfBuddyMasterData()
  },
  methods: {
    async handleGetMember() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getMember()
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.memberListData = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    async getMember() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          pageId: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset
        }

        Object.entries(vm.filter).forEach(([key, value]) => {
          if (value && Object.keys(value).length > 0) {
            Object.assign(data, { [key]: value.value })
          }
          if (value && value.length) {
            Object.assign(data, { [key]: value.toLowerCase() })
          }
        })

        const response = await gpfBuddyApi.getMember({
          config: {
            params: data
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      const response = await vm.getMember()
      const requestData = response.data.data
      vm.isExport = false

      if (requestData == null) return
      const requests = requestData.map((el) => {
        return {
          id: el.gpf_user_id,
          full_name: el.full_name,
          company: el.company_name,
          group: el.group_name,
          department: el.department_name,
          position: el.position_name
        }
      })

      const heading = [['รหัสพนักงาน', 'ชื่อ', 'บริษัท', 'ฝ่าย', 'แผนก', 'ตำแหน่ง']]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `gpf-buddy-members.xlsx`)
    },
    async handleSyncMember() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const responseSyncEmployee = await vm.syncEmployee()
        const responseSyncCompany = await vm.syncCompany()
        vm.$store.dispatch('loading')

        if (
          responseSyncEmployee &&
          responseSyncEmployee.status === 200 &&
          responseSyncCompany &&
          responseSyncCompany.status === 200
        ) {
          vm.reset()
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    async syncEmployee() {
      const vm = this
      try {
        const response = await gpfBuddyApi.postSyncEmployee({
          data: {
            pageId: vm.selectedBot.pageid
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async syncCompany() {
      const vm = this
      try {
        const response = await gpfBuddyApi.postSyncCompany({
          data: {
            pageId: vm.selectedBot.pageid
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleSearch() {
      this.reset()
      this.handleCloseSearch()
    },
    handleClearSearch() {
      this.filter = {
        gpf_user_id: '',
        full_name: '',
        company_name: '',
        group_name: '',
        department_name: '',
        position_name: ''
      }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleGetMember()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetMember()
    },
    handleChangeSort() {
      this.reset()
    },
    async getGpfBuddyMasterData() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid
        }
        const response = await gpfBuddyApi.getCompanyMasterData({ config: data })
        if (response && response.status === 200) {
          vm.$store.state.gpfBuddyMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>
tr > td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/GpfBuddy/Member.vue